var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"article-form-info-icon",attrs:{"title":_vm.i18n.t('showInformation'),"data-testid":"article-form-info-icon"},on:{"click":function($event){return _vm.clicked()}}},[_c('i',{staticClass:"fas fa-question-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }